export function uploadResponseError(status, body = {}, retryAfter = null, now = Date.now()) {
  const error = new Error(body.message || body.error || `Upload failed: ${status}`);
  error.status = status;
  error.code = body.code || (body.error === 'uploads_paused' ? body.error : undefined);
  error.retryAfter = retryAfter;
  const seconds = typeof retryAfter === 'string' && /^\d+$/.test(retryAfter.trim()) ? Number(retryAfter.trim()) : NaN;
  const date = typeof retryAfter === 'string' ? Date.parse(retryAfter) : NaN;
  error.retryAt = Number.isFinite(seconds) ? now + seconds * 1000 : Number.isFinite(date) ? Math.max(now, date) : now + 60000;
  return error;
}
export const isUploadPaused = error => error?.code === 'uploads_paused' || ([429,503].includes(error?.status) && error?.retryAfter != null);
export const blocksUploadFallback = error => isUploadPaused(error) || error?.uploadTransferred === true;

// A server pause stops the whole batch, even if its delay expires while another
// transfer finishes. Only an explicit later attempt reopens admission.
export function createUploadPauseGate(clock = Date.now) {
  let paused = null;
  return {
    get paused() { return paused; },
    start() { if (paused && clock() < paused.retryAt) return false; paused = null; return true; },
    stop(error) {
      if (!isUploadPaused(error)) return false;
      paused = { code: error.code, status: error.status, retryAfter: error.retryAfter, retryAt: Math.max(paused?.retryAt || 0, error.retryAt || clock() + 60000) };
      return true;
    }
  };
}
